exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feature-list[data-v-e140703a]{--icon-border-radius:5px;padding-top:50px;grid-row-gap:50px}.tab[data-v-e140703a]{margin-bottom:0}.half-grid[data-v-e140703a]{grid-column:1/-1;text-align:left}@media (min-width:48em){.half-grid[data-v-e140703a]{grid-column:span calc(var(--numCols) / 2);text-align:left}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e140703a","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/vuejs/frontend/2023-launch/components/FeaturesList.vue
// module id = Y+vd
// module chunks = 4